import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "flex align_center"
};
const _hoisted_2 = {
  class: "info"
};
import { ref, watch } from "vue";
// 定义Props
export default /*#__PURE__*/_defineComponent({
  __name: 'SensitiveInformation',
  props: {
    value: String
  },
  setup(__props) {
    const props = __props;
    const isShowFullInfo = ref(false);
    const msg = ref("");
    const sourceMsg = ref("");
    watch(() => props.value, v => {
      if (v) {
        sourceMsg.value = msg.value = v.trim();
        hideFullInfo();
      }
    }, {
      deep: true,
      immediate: true
    });
    function showFullInfo() {
      isShowFullInfo.value = true;
      msg.value = sourceMsg.value;
    }
    function hideFullInfo() {
      isShowFullInfo.value = false;
      if (sourceMsg.value.length > 0) {
        if (sourceMsg.value.length < 3) {
          if (sourceMsg.value.length == 1) {
            msg.value = sourceMsg.value.replace(/^(.{1})/, `$1*`);
          } else {
            msg.value = sourceMsg.value.replace(/^(.{1})(.*)(.{1})/, `$1*$3`);
          }
        } else {
          //   let reg = /^(.{3})(.*)(.{4})/.test(sourceMsg.value);
          //   msg.value = `${RegExp.$1}${new Array(RegExp.$2.length).join("*")}${RegExp.$3}`;
          if (sourceMsg.value.length < 8) {
            msg.value = sourceMsg.value.replace(/^(.{3})(.*)(.{1})$/, function (match, p1, p2, p3) {
              return p1 + "*".repeat(p2.length) + p3;
            });
          } else {
            msg.value = sourceMsg.value.replace(/^(.{3})(.*)(.{4})$/, function (match, p1, p2, p3) {
              return p1 + "*".repeat(p2.length) + p3;
            });
          }
        }
      }
    }
    return (_ctx, _cache) => {
      const _component_Icon = _resolveComponent("Icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", _hoisted_2, _toDisplayString(msg.value), 1), _createTextVNode("  "), msg.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [isShowFullInfo.value ? (_openBlock(), _createBlock(_component_Icon, {
        key: 0,
        fontClassName: "iconfont",
        name: "icon-shangpinyun_chakan",
        color: "#666",
        style: {
          "font-size": "12px"
        },
        onClick: hideFullInfo
      })) : (_openBlock(), _createBlock(_component_Icon, {
        key: 1,
        fontClassName: "iconfont",
        name: "icon-shangpinyun_yincang",
        color: "#666",
        style: {
          "font-size": "12px"
        },
        onClick: showFullInfo
      }))], 64)) : _createCommentVNode("", true)]);
    };
  }
});